<template>
    <div class="upload-box" :class="{ 'upload-box--focusable' : !disabled }">
        <div class="upload-box--content">
            <label
                for="upload-files"
                :tabindex="disabled ? '-1' : '0'"
                @keyup.enter="onKeyUp"
            >
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 46"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.636 32.857h10.637a5.722 5.722 0 0 0 4.048-1.686A5.768 5.768 0 0 0 36 27.107V5.75a5.768 5.768 0 0 0-1.68-4.064A5.722 5.722 0 0 0 30.274 0H5.727A5.722 5.722 0 0 0 1.68 1.686 5.768 5.768 0 0 0 0 5.75v21.357a5.768 5.768 0 0 0 1.68 4.064 5.722 5.722 0 0 0 4.047 1.686h10.637v11.5c0 .436.172.854.479 1.162a1.633 1.633 0 0 0 2.314 0c.307-.308.48-.726.48-1.162v-11.5Zm0 0h-3.272V17.11l-5.39 5.41a1.633 1.633 0 0 1-2.283-.03 1.646 1.646 0 0 1-.03-2.293l8.182-8.214a1.633 1.633 0 0 1 2.314 0l8.181 8.214a1.647 1.647 0 0 1-.029 2.293 1.634 1.634 0 0 1-2.284.03l-5.389-5.41v15.748Z" fill="#fff" fill-opacity=".5"/></svg>
                <h3><strong>Drag &amp; drop</strong> or choose&nbsp;files</h3>
                <span>to automatically start your&nbsp;conversion</span>
            </label>
            <input
                type="file"
                id="upload-files"
                ref="upload"
                name="upload"
                multiple
                :disabled="disabled"
                @change="changeFile"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "UploadBox",
    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onKeyUp() {
            this.$refs.upload.click();
        },
        changeFile(e) {
            this.$emit('change', e.target.files);
        }
    }
}
</script>

<style>
.upload-box {
    background-color: #212121;
    border: 1px solid #434343;
    border-radius: 5px;
    transition: background-color .25s, box-shadow .25s;
}

.upload-box:hover {
    background-color: #434343;
}

.upload-box--focusable:focus,
.upload-box--focusable:focus-within {
    box-shadow: 0px 0px 0px 3px #0071EA;
}

.upload-box label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 35px;
    cursor: pointer;
    text-align: center;
}

.upload-box h3 {
    margin: 0;
    font-weight: 600!important;
    font-size: 20px!important;
}

.upload-box span {
    color: currentColor;
    opacity: .5;
}

.upload-box h3 strong {
    font-weight: 800!important;
}

.upload-box svg {
    width: 30px;
    margin-bottom: 15px;
}

.upload-box input[type="file"] {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/UploadBox.vue